/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import RenderButtons from 'components/RenderButtons';
import {useHeaderNbi, useListClientContacts, useListContactsByType} from 'services/QuoteService';
import { useOperationInfo } from 'services/OperationService'; 
import { usePolicyPackSendDirector } from 'services/PolicyService';

import { Title } from "./styles";

export default function SendPaymentPackInsurerClient(props) {
  const [idProduct, setIdProduct] = useState(null);
  const [summary, setSummary] = useState({});
  const authContext = useContext(GlobalAuthContext);
  const [selectedItems2, setSelectedItems2] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [insurers, setInsurers] = useState([]);
  const [client, setClient] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "Send Policy Pack Director",
    route: "",
  });

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useListClientContactsData,
    loading: useListClientContactsLoading,
    error: useListClientContactsError,
    status: useListClientContactsStatus,
    request: useListClientContactsRequest,
  } = useListClientContacts(props.match.params.idOperationRoot || props.match.params.idOperation);

  const {
    data: useListContactsByTypeData,
    loading: useListContactsByTypeLoading,
    error: useListContactsByTypeError,
    status: useListContactsByTypeStatus,
    request: useListContactsByTypeRequest,
  } = useListContactsByType('insurer', props.match.params.idOperation);

  const {
    data: usePolicyPackSendDirectorData,
    loading: usePolicyPackSendDirectorLoading,
    error: usePolicyPackSendDirectorError,
    status: usePolicyPackSendDirectorStatus,
    request: usePolicyPackSendDirectorRequest,
  } = usePolicyPackSendDirector();

  useEffect(() => {
    if (useHeaderNbiLoading || useOperationInfoLoading || useListClientContactsLoading || usePolicyPackSendDirectorLoading || useListContactsByTypeLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useOperationInfoLoading, useListClientContactsLoading, usePolicyPackSendDirectorLoading, useListContactsByTypeLoading]);

  const validation = () => {
    if (selectedItems2.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({data: response}) => {
        setIdProduct(response?.idProduct);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }

  function handleSelectInsurer(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
      setSelectedItems(filteredItems);
    } else {
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
      console.log("list de contactos", selectedItems);
    };
  };

  function handleSend() {
    let valid = validation();
    if (valid != true) {
      mc.error('Please fill in all required fields.');
      return
    }

    fitinsur.setAuthToken(authContext.token);
    let insuresContacts = [];

    let clientContacts = []
    selectedItems2.map(x => {
      clientContacts.push({ idContact: x.idContact, email: x.email });
    })


    insurers.forEach(x => {
      insuresContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedItems.map(selectedInsurer => {
      let insurer = insuresContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let body = {
      idOperation: props.match.params.idOperation,
      policyPackSendDirectorMessage: formik.current.values.policyPackSendDirectorMessage,
      client: clientContacts,
      insurers: insuresContacts,
    };

    usePolicyPackSendDirectorRequest({...body}).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        return history.push('/policies');
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function listContactsClients() {
    useListClientContactsRequest().then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        if (data.ret_value.length >= 1) {
          setClient(data.ret_value);
        }
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };

  function listContacts(idContactDepartment) {
    useListContactsByTypeRequest(null, {idContactDepartment: idContactDepartment}, null, `/quote/insurer/list-contacts/${props.match.params.idOperation}?`).then(({data}) => {
      if (data.ret_code != 200) {
        mc.error(data.ret_msg_details);
        history.goBack();
        return;
      }

      const insurers = data.ret_value?.sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer))) || [];
      setInsurers(insurers);
    })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };


  function handleSelectClient(e) {
    const contact = { idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems2.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems2.filter((item) => item.email !== contact.email);
      setSelectedItems2(filteredItems);
    } else {
      let list = [...selectedItems2];
      list.push(contact);
      setSelectedItems2([...list]);
    };
  };

  const listItems2 = client.map((client) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px", marginBottom: '5px' }}>
        <Col style={{ flexDirection: "row", display: "flex" }}>
          <label>
            <CheckBox
              onChange={() => { handleSelectClient(client) }}
              checked={selectedItems2.find((item) => item.email === client.email) ? true : false}
              disabled={client.existContact ? true : false}
            />
          </label>
          <Label>
            {client.nameContact}
          </Label>
        </Col>
        <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <Label>{client.email}</Label>
        </Col>
      </Row>
    </>
  ));

  const listItems = insurers.length ? insurers.map((insurer) => (
      <>
        <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
          <Title>
            {insurer.insurerFirstName}
          </Title>
        </Row>

        {insurer.contacts.length ? insurer.contacts.map((contact) => (
            <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
              <Col md={4} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                <label>
                  <CheckBox
                    onChange={() => { handleSelectInsurer(contact, insurer) }}
                    checked={selectedItems.find((item) => item.email === contact.email) ? true : false}
                  />
                </label>
                <Label>{contact.legalEntity}</Label>
              </Col>
              <Col md={3} style={{ flexDirection: "row", display: "flex" }}>
                <Label>
                  {contact.nameContact}
                </Label>
              </Col>
              <Col md={2} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                <Label>{contact.personContactDepartment}</Label>
              </Col>
              <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
                <Label>{contact.email}</Label>
              </Col>
            </Row>
          ))
          :
          (
            <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
              <Label>
                No results found.
              </Label>
            </Row>
          )}
      </>
    ))
    :
    (
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Label>
          No results found.
        </Label>
      </Row>
    );

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleSummary();
    listContactsClients();
    listContacts();
    handleOperationInfo();
  }, [])

  useEffect(() => {

    if (endorsmentType === 'adjustments-corrections') {
      setStatusEndorsement({
        title: "ADJUSTMENTS AND CORRECTIONS / SEND POLICY PACK",
        route: ''
      })
    }
  }, [endorsmentType])

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <ContentCard title={statusEndorsement.title} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{ policyPackSendDirectorMessage: '' }}
          onSubmit={handleSend}
        >
          {formikProps => (
            <Form>
              <>
                <Title>TO - CLIENT</Title>
                {listItems2}
              </>
              <br></br>
              <>
                <Title>TO - INSURERS</Title>
                {listItems}
              </>
              <br></br>
              <Field
                label="Policy pack send director message"
                name={'policyPackSendDirectorMessage'}
                value={formikProps.values.policyPackSendDirectorMessage}
                onChange={(e) => formikProps?.setFieldValue('policyPackSendDirectorMessage', e)}
                component={TextField}
              />

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <>
                      <Button
                        style={{ marginLeft: "30px" }}
                        primary
                        type="submit"
                        id="btnSubmit"
                      >
                        SEND POLICY PACK
                      </Button>
                    </>
                  </ButtonContent>
                </RenderButtons>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
